import smallFitnessScreen from 'images/landing/features/screens/fitness/small.png'
import mediumFitnessScreen from 'images/landing/features/screens/fitness/medium.png'
import largeFitnessScreen from 'images/landing/features/screens/fitness/large.png'

import smallRideScreen from 'images/landing/features/screens/ride/small.png'
import mediumRideScreen from 'images/landing/features/screens/ride/medium.png'
import largeRideScreen from 'images/landing/features/screens/ride/large.png'

import smallRunScreen from 'images/landing/features/screens/run/small.png'
import mediumRunScreen from 'images/landing/features/screens/run/medium.png'
import largeRunScreen from 'images/landing/features/screens/run/large.png'

import smallWalkScreen from 'images/landing/features/screens/walk/small.png'
import mediumWalkScreen from 'images/landing/features/screens/walk/medium.png'
import largeWalkScreen from 'images/landing/features/screens/walk/large.png'

import smallHikeScreen from 'images/landing/features/screens/hike/small.png'
import mediumHikeScreen from 'images/landing/features/screens/hike/medium.png'
import largeHikeScreen from 'images/landing/features/screens/hike/large.png'

const flavorScreens = {
  fitness: {
    src: smallFitnessScreen,
    medium: mediumFitnessScreen,
    xlarge: largeFitnessScreen,
  },
  ride: {
    src: smallRideScreen,
    medium: mediumRideScreen,
    xlarge: largeRideScreen,
  },
  run: {
    src: smallRunScreen,
    medium: mediumRunScreen,
    xlarge: largeRunScreen,
  },
  walk: {
    src: smallWalkScreen,
    medium: mediumWalkScreen,
    xlarge: largeWalkScreen,
  },
  hike: {
    src: smallHikeScreen,
    medium: mediumHikeScreen,
    xlarge: largeHikeScreen,
  },
}
export default flavorScreens



// WEBPACK FOOTER //
// ./src/components/landing/features/screens.js